/*
 * File: PageSubHeader.tsx
 * Project: rosita
 * -----
 * Last Modified: 18 Feb 2022 4:38:40 pm
 * -----
 * Copyright (c) 2022 Elegant Software Solutions All rights reserved.
 */

import { DeleteOutlined } from '@ant-design/icons';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { Col, Menu, Row } from 'antd';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useGetApplicationQuery } from 'redux/services/freddyCadabby/freddyCadabbyApi';
import { InlineStylesModel } from '../../models/InlineStylesModel';

const styles: InlineStylesModel = {
  row: {
    backgroundColor: '#181823',
    padding: '0 50px',
    color: '#84859a',
    fontSize: '1rem',
    maxWidth: 1920,
    margin: '0 auto'
  },
  menuContainer: {
    height: '100%',
    width: '100%',
    minWidth: 233
  },
  row2: {
    width: '100%',
    maxWidth: 1920
  }
};

export const PageSubHeader = (): JSX.Element => {
  const [selectedMenu, _setSelectedMenu] = useState<string>('search');
  const { pathname } = useLocation();
  const applicationId = pathname.includes('/applications/') && pathname.split('/')[2];
  const isRecyclingBinPage = pathname.includes('/recycling-bin');
  const isCreatePage = pathname.includes('create');

  let customerName = '';

  /* ******************** API Hooks ******************** */
  const { data: applicationData, isFetching: isApplicationDataFetching } = useGetApplicationQuery(applicationId || skipToken);

  if (applicationData && !isApplicationDataFetching && applicationId && !isRecyclingBinPage && !isCreatePage) {
    customerName = `Application - ${applicationData?.name}`;
  } else {
    customerName = '';
  }

  useEffect(() => {
    if (pathname.includes('/create')) _setSelectedMenu('create');
    if (pathname.includes('/recycling-bin')) _setSelectedMenu('recycling');
    if (!pathname.includes('/create') && !pathname.includes('/recycling-bin')) _setSelectedMenu('search');
  }, [pathname]);

  // JSX
  const featureMenuJSX = (
    <Menu disabledOverflow={true} mode="horizontal" theme="dark" style={styles.menuContainer} activeKey={selectedMenu} defaultSelectedKeys={[selectedMenu]} selectedKeys={[selectedMenu]}>
      <Menu.Item key="search">
        <Link to="/">Search</Link>
      </Menu.Item>
      <Menu.Item key="create">
        <Link to="/create/user-details">Create</Link>
      </Menu.Item>
      <Menu.Item key="recycling">
        <Link to="/users/recycling-bin">
          <DeleteOutlined />
        </Link>
      </Menu.Item>
    </Menu>
  );

  return (
    <div style={{ width: '100%', backgroundColor: 'rgb(24, 24, 35)' }}>
      <Row style={styles.row} justify="space-between" align="middle">
        <Col>{customerName}</Col>
        <Col>{featureMenuJSX}</Col>
      </Row>
    </div>
  );
};
